import { useTranslation } from 'react-i18next'
import React from 'react'

import FormItem from '../../../components/form/FormItem'
import ListOfInputs from '../../../components/form/ListOfInputs'
import { useSelectedQuestion } from '../../../modules/checklists/edit/_form/ChecklistFormHandler'

const QuestionOptionsInputs = ({ question, onChange, onRemove }) => {
  const { t } = useTranslation('checklists')
  const selectedQuestion = useSelectedQuestion()

  return (
    <FormItem label={t('options')} field="options">
      <ListOfInputs key={selectedQuestion.reference} onChange={onChange} onRemove={onRemove} value={question.options} />
    </FormItem>
  )
}

export default QuestionOptionsInputs
